import { Alert, Group, Loader, Stack, Text } from "@mantine/core";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { ProposalCard } from "./ProposalCard";
import { useProposals } from "./useProposals";

// Список карточек предложений самообучения.
//
// Состояния loading/error/empty — по образцу QuotaIndicator. Порядок
// (pending сверху) приходит с backend — список не пересортировываем.
// Сам зовёт useProposals; страница просто рендерит <SelfImprovementList/>.
export function SelfImprovementList(): ReactElement {
  const { t } = useTranslation();
  const proposals = useProposals();

  if (proposals.isLoading) {
    return (
      <Group gap="xs">
        <Loader size="sm" />
        <Text size="sm" c="dimmed">
          {t("selfImprovement.loading")}
        </Text>
      </Group>
    );
  }

  if (proposals.isError) {
    return (
      <Alert color="red" title={t("selfImprovement.loadError")}>
        {proposals.error.message}
      </Alert>
    );
  }

  const items = proposals.data?.proposals ?? [];
  if (items.length === 0) {
    return <Text c="dimmed">{t("selfImprovement.empty")}</Text>;
  }

  return (
    <Stack gap="md">
      {items.map((proposal) => (
        <ProposalCard key={proposal.id} proposal={proposal} />
      ))}
    </Stack>
  );
}
